<svelte:head>
  <script>
    var DDCONF = { API_KEY: "s1AXGaz4XfAxRY6O" };
  </script>
  <script async src="https://doublethedonation.com/api/js/ddplugin.js"></script>
</svelte:head>

<div id="dd-container" data-chromatic="ignore" />
